define(['jquery', 'ps/modal', 'modernizr'], function($, PSModal) {

    /**
     * Tworzy modal dla warunków wynajmu.
     * Pobiera zdalnie treść warunków wynajmu biorąc jako źródło atrybut href
      * @param e
     */
    var ModalTerms = function(e) {
        e.preventDefault();

        var href = $(this).attr('href');

        var $loader = $('<div class="progress-circle-indeterminate">');

        var $modal = PSModal.create({
            title: 'Warunki wynajmu',
            body: $loader,
            modalClass: 'rc-rwd-full fade'
        });
        
        // przy zamykaniu modala na iOS przywracamy CSS:position na <body>
        if(Modernizr.touchevents) {
            $modal.on('hide.bs.modal', function() {
                $('body').css('position', 'static');
            });
        }

        $.ajax({
            url: href,
            data: {
                modal: true
            },
            success : function(data, textStatus, jqXHR) {
                $modal.find('.modal-body').html(data);
                
                // ustawiamy CSS:position fixed na <body>, aby działał scroll
                if(Modernizr.touchevents) {
                    $('body').css('position', 'fixed');
                }
            }
        });
    };

    return ModalTerms;
});